import { FC } from "react";
import { _ } from "../../utils/helpers";
import { Icon } from "../Icon";

interface AddButtonProps {
    qty: number
    max?: number
    min?: number
    autoFocus?: boolean
    className?: string
    alwaysDisplayCounter?: boolean
    onAddButtonClick: (newQty: number) => void
}

export const AddButton: FC<AddButtonProps> = ({qty, max, min, onAddButtonClick, autoFocus, className, alwaysDisplayCounter}) => {

    return (
        <div className={`df aic jcc add-button ${className ?? ''}`}>
        {   (qty === 0 && !alwaysDisplayCounter) ? 
            <button 
                aria-label={_('0ge_add____')}
                className="button b-0 py-3 w-100 text s18-500 center r2 outline-shadow shadow"
                onClick={() => onAddButtonClick(1)}
            >
                {_('0ge_add____')}
            </button>
            :
            <>
             <button 
                aria-label={_('0ge_remov__')}
                disabled={min !== undefined && qty <= min}
                className="button b-0 df aic jcc p-0 min h-100 r2 py-3 outline-shadow shadow"
                onClick={() => onAddButtonClick(qty - 1)}
            >
                <Icon icon="minus-alternative" aria-hidden/>
            </button>
            <span className="text s18-500 center value" aria-live="assertive">{qty}</span>
            <button 
                aria-label={_('0ge_add____')}
                disabled={max !== undefined && qty >= max}
                className="button b-0 df aic jcc p-0 max h-100 r2 py-3 outline-shadow shadow"
                onClick={() => onAddButtonClick(qty + 1)}
            >
                <Icon icon="plus-alternative" aria-hidden/>
            </button>
            </>
        }
        </div>
    )
}